module.exports = __webpack_public_path__ + "img/xiangpica.4e13cc8d.png";